import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, type BreadcrumbLinkMouseEvent } from '@progress/kendo-react-layout';
import { Button } from '@progress/kendo-react-buttons';
import type { LayoutProps } from './layout.types.ts';
import { QuickDashboard } from '../dashboard/quick-dashboard.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../../context/auth-context.ts';
import { SupportDialog } from '../../dialog/support-dialog.tsx';
import logo from '../../assets/logo.png';
import styles from './layout.module.scss';
import { LayoutDrawerPosition } from './layout-drawer.types.ts';

export function Layout({ children, breadcrumb, renderDrawer }: LayoutProps) {
  const { userSession } = useContext(AuthContext)!;
  const navigate = useNavigate();

  const [showQuickDash, setShowQuickDash] = useState(false);
  const [showSupportDialog, setSupportDialog] = useState(false);

  const handleBreadcrumbLinkSelect = ({ id }: BreadcrumbLinkMouseEvent) => {
    const item = breadcrumb[breadcrumb.findIndex((prev) => prev.id === id)];
    if (item.url) {
      navigate(item.url);
    }
  };

  const handleLogoNavigate = () => {
    navigate('/');
  };

  const handleQuickDashToggle = () => {
    setShowQuickDash((prev) => !prev);
  };

  const handleSupportDialogOpen = () => {
    setSupportDialog(true);
  };

  const handleSupportDialogClose = () => {
    setSupportDialog(false);
  };

  const handleKoreNavigate = () => {
    window.open(import.meta.env.VITE_KORE_URL, '_blank');
  };

  return (
    <>
      <div className={styles.navbar}>
        <div className={styles.navbarLogo} onClick={handleLogoNavigate}>
          <img src={logo} alt={'Logo'} />
        </div>
        <div className={styles.navbarActions}>
          <Button onClick={handleQuickDashToggle} className={styles.navbarActionUser}>
            {userSession!.forename.at(0)}
            {userSession!.surname.at(0)}
          </Button>
          <Button onClick={handleSupportDialogOpen}>
            <FontAwesomeIcon icon={faQuestion} size={'xl'} />
          </Button>
          <Button className={styles.navbarActionKore} onClick={handleKoreNavigate}>
            <img src={'/favicon.ico'} alt={'KORE'} />
          </Button>
        </div>
      </div>
      <div className={styles.breadcrumb}>
        <Breadcrumb data={breadcrumb} onItemSelect={handleBreadcrumbLinkSelect} size={'small'} />
      </div>
      <div className={styles.body}>
        <div className={styles.container}>
          {renderDrawer?.left && renderDrawer.left(LayoutDrawerPosition.Left)}
          <div className={styles.content}>{children}</div>
          {renderDrawer?.right && renderDrawer.right(LayoutDrawerPosition.Right)}
        </div>
      </div>
      {showQuickDash && <QuickDashboard onClose={handleQuickDashToggle} />}
      {showSupportDialog && <SupportDialog onClose={handleSupportDialogClose} />}
    </>
  );
}
